"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var g2_1 = require("@antv/g2");
var LineSelect = /** @class */ (function (_super) {
    tslib_1.__extends(LineSelect, _super);
    function LineSelect(cfg) {
        return _super.call(this, tslib_1.__assign({ endEvent: 'click' }, cfg)) || this;
    }
    LineSelect.prototype.end = function (ev) {
        var target = ev.target;
        if (target.name === 'line') {
            var data_1 = ev.data[0]._origin;
            this.view.setInactive(function (obj) {
                return obj !== data_1;
            });
            // TODO： 设置z-index
        }
        else {
            this.view.setInactive(function () {
                return false;
            });
            // TODO: 重置z-index
        }
    };
    return LineSelect;
}(g2_1.Interaction));
exports.default = LineSelect;
//# sourceMappingURL=line-select.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/line/interaction/line-select.js
// module id = 929
// module chunks = 37